<template>
    <div class="wallet" :class="{ 'wallet--page': $route.path === '/Wallet' }">
        <div class="wallet__switch" role="tablist">
            <button
                v-for="item in items"
                :key="item"
                type="button"
                role="tab"
                :aria-selected="defaultValue === item"
                :class="{ 'wallet__switch--active': defaultValue === item }"
                @click="defaultValue = item"
            >
                {{ item }}
            </button>
        </div>
        <card v-if="defaultValue === 'Paron Card'"/>
        <members-card v-else/>
        <p class="wallet__hint">
            <v-icon small color="rgba(27,47,90,0.6)" class="mr-1">mdi-gesture-tap</v-icon>
            Πατήστε την κάρτα για να δείτε την πίσω όψη. Δείξτε την στο κατάστημα για να λάβετε την έκπτωση.
        </p>
    </div>
</template>

<script>
    import restApi from "@/rest-api"
    import card from "@/components/Card"
    import MembersCard from "@/components/MembersCard"

    export default {
        components: { card, MembersCard },
        data: () => ({
            deg: 0,
            front: true,
            url: 'https://google.gr',
            isMobile: false,
            items: ['Paron Card', 'Members Paron Card'],
            defaultValue: 'Paron Card',
            isParon: true
        }),
        created() {
            if (this.$route.query.card && this.$route.query.initials) {
                var filter = {
                    "number": this.$route.query.card,
                    "initials": this.$route.query.initials
                }
                var search = `/card/filtered`
                restApi
                .post(search, filter)
                .then(response => {
                    this.$store.dispatch('clearSession')
                    this.$store.dispatch("setCard", response.data[0].number)
                    let memberInfo = response.data[0].member.firstName.charAt(0) + response.data[0].member.lastName.charAt(0)
                    this.$store.dispatch("setFirstName", response.data[0].member.firstName)
                    this.$store.dispatch("setLastName", response.data[0].member.lastName.replace('-',''))
                    this.$store.dispatch("setInitials", memberInfo)
                    this.$store.dispatch("setParonMember", response.data[0])
                    this.$store.dispatch("setExpirationDate", response.data[0].expirationDate)
                    this.$emit('showSecret')
                })
                .catch((error) => {
                    console.log(error)
                })
            }
        },
        beforeDestroy () {
            if (typeof window === 'undefined') return window.removeEventListener('resize', this.onResize, { passive: true })
        },
        mounted () {
            this.onResize()
            window.addEventListener('resize', this.onResize, { passive: true })
        },
        methods: {
            getImage() {
                return this.front? require('@/assets/cards/masoutis_front.png') : require('@/assets/cards/masoutis_back.png')
            },
            onResize() {
                this.isMobile = window.innerWidth < 600
            },
            showCard() {
                if (this.defaultValue === 'Π.Α.Ρ.Ο.Ν.') {
                    this.isParon = true
                } else {
                    this.isParon = false
                }
            },
            getFormatedDate() {
                let objectDate = new Date(this.$store.getters.getExpirationDate.expirationDate)

                let day = objectDate.getDate()

                let month = objectDate.getMonth()

                let year = objectDate.getFullYear()

                return day + "/" + month + "/" + year
            }
        }
    }

</script>

<style lang="scss" scoped>
    .wallet {
        padding: 4px 0 8px;
        text-align: center;
    }

    .wallet--page {
        padding: 40px 18px 64px;
    }

    .wallet__switch {
        display: inline-grid;
        grid-template-columns: 1fr 1fr;
        gap: 4px;
        margin-bottom: 20px;
        padding: 4px;
        border-radius: 12px;
        background: #f2f4f8;
    }

    .wallet__switch button {
        padding: 8px 16px;
        border-radius: 9px;
        color: #1b2f5a;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
        transition: background-color 0.15s ease, box-shadow 0.15s ease;
    }

    .wallet__switch .wallet__switch--active {
        background: #fff;
        color: #ad282d;
        box-shadow: 0 1px 4px rgba(27, 47, 90, 0.16);
    }

    .wallet__hint {
        display: block;
        max-width: 420px;
        margin: 8px auto 0;
        font-size: 13px;
        color: rgba(27, 47, 90, 0.65);
    }
</style>